import { useEffect, useMemo, useState } from "react";
import {
  userIsLogged,
  getRoute,
  apiPostAvpArcoAdd,
  apiGetAvpAssistenteById,
  apiGetAvpGrafo,
  apiGetAllSysLingue,
  apiGetAvpNodoTipoAvvio,
} from "../shared/manager/api_manager";
import { useNavigate } from "react-router-dom";
import { getValueByQueryString } from "../shared/manager/util";
import AvpHeader from "../shared/header/AvpHeader";
import BreadCrumb from "../shared/header/BreadCrumb";
import { useEffectOnce } from "../shared/manager/use_effect_once";
import NewGraph from "./test-graph/test-graph";
import { Fullscreen } from "@mui/icons-material";
import zIndex from "@mui/material/styles/zIndex";
import GraphEditComponent from "./graph-edit-component";
import { useGraphStore } from "./test-graph/store";
import Collapse from "@mui/material/Collapse";
import Alert from "@mui/material/Alert";
import { useLingueStore } from "../sistema/storeLingua";

export default function NewGraphScreen() {
  const {
    selectedLingua,
    setSelectedLingua,
    avp,
    setAvp,
    alertMessage,
    setAlertMessage,
  } = useGraphStore((state) => state);

  const memoAlert = useMemo(() => {
    return alertMessage;
  }, [alertMessage]);

  const navigate = useNavigate();
  const { selectedLinguaTesto } = useLingueStore((state) => state);

  const [avpAssistente, setAvpAssistente] = useState([]);
  const [tipoAvvioList, setTipoAvvioList] = useState([]);
  // const [currentAvpLingua, setCurrentAvpLingua] = useState(null);
  const [avpLingue, setAvpLingue] = useState([]);
  // const [avpGrafo, setAvpGrafo] = useState(null);

  // const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  // const [alertErrorOpen, setAlertErrorOpen] = useState(false);

  const [breadCrumb, setBreadCrumb] = useState([
    { title: selectedLinguaTesto?.AvpGraphDetailbreadCrumb1, link: "/avp" },
    { title: selectedLinguaTesto?.AvpGraphDetailbreadCrumb1, link: null },
    { title: selectedLinguaTesto?.AvpGraphDetailbreadCrumb1, link: null },
  ]);

  const aggiungiBreadcrumb = (title, link) => {
    if (!breadCrumb.find((item) => item.title === title)) {
      setBreadCrumb([...breadCrumb, { title, link }]);
    }
  };
  useEffectOnce(() => {
    startPage();
  });

  function startPage() {
    console.log("startPage");
    if (userIsLogged() == false) {
      navigate("/login");
    } else {
      var route = getRoute();
      if (!route.funzioni.some((g) => g.idFunzione === 20)) {
        navigate("/");
      }
      initPage();
    }
  }

  function initPage() {
    console.log("initPage");

    loadLingue();
  }

  function loadLingue() {
    console.log("loadLingue");

    apiGetAllSysLingue(function (response) {
      loadNodoTipoAvvio();
      loadAvp();
    });
  }

  function loadNodoTipoAvvio() {
    apiGetAvpNodoTipoAvvio(function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setTipoAvvioList(response.data);
      }
    });
  }
  function loadAvp() {
    const url = window.location.pathname;
    const idAvp = url.substring(url.lastIndexOf("/") + 1);

    if (idAvp != null && idAvp != "") {
      apiGetAvpAssistenteById(idAvp, avpCallback);
    } else {
      setAvpAssistente(null);
    }
  }
  function setUpLingua(avp) {
    debugger;

    let requestedLingua = null;
    if (selectedLingua == null || selectedLingua == undefined) {
      //check query param
      const queryIdLingua = getValueByQueryString("idlingua");
      if (
        queryIdLingua !== null &&
        queryIdLingua !== "undefined" &&
        queryIdLingua.length > 0
      ) {
        if (avp.lingue != null && avp.lingue.length > 0) {
          for (var i = 0; i < avp.lingue.length; i++) {
            if (avp.lingue[i].idLingua == queryIdLingua) {
              requestedLingua = avp.lingue[i];
              break;
            }
          }
        }
      }

      if (requestedLingua == null) {
        if (avp.lingue != null && avp.lingue.length > 0) {
          requestedLingua = avp.lingue[0];
          // for (var i = 0; i < avp.lingue.length; i++) {
          //   if (avp.lingue[i].linguaDefault) {
          //     requestedLingua = avp.lingue[i];
          //     break;
          //   }
          // }
        }
        //get default
        // if (avp.lingue != null && avp.lingue.length > 0) {
        //   for (var i = 0; i < avp.lingue.length; i++) {
        //     if (avp.lingue[i].linguaDefault) {
        //       requestedLingua = avp.lingue[i];
        //       break;
        //     }
        //   }
        // }
      }
      setSelectedLingua(requestedLingua);
      // setCurrentAvpLingua(requestedLingua);
    } else {
      requestedLingua = selectedLingua;
    }

    console.log("requestedLingua", requestedLingua);
    return requestedLingua;
  }

  function avpCallback(response) {
    if (response != null && response.status >= 200 && response.status < 400) {
      console.log("AvpAssistente", response.data);
      aggiungiBreadcrumb(response.data.descAssistente, null);

      let lingua = setUpLingua(response.data);
      debugger;

      loadGrafo(response.data, lingua.idLingua);
    }
  }

  function loadGrafo(pAvp, idLingua) {
    if (pAvp != null) {
      setAvpLingue(pAvp.lingue);

      apiGetAvpGrafo(pAvp.idAvp, idLingua, function (response) {
        setAvp(response.data);
        setAvpAssistente(pAvp);
      });
    }
  }
  function handleNodeActionCallback(action, idNodo, idArco) {
    console.log(
      "nodeAction: " + action + "  idNodo: " + idNodo + "   idArco: " + idArco
    );
    if (action == "changeLang") {
      let lingua = null;
      if (avpLingue != null && avpLingue.length > 0) {
        for (var i = 0; i < avpLingue.length; i++) {
          if (avpLingue[i].idLingua == idNodo) {
            lingua = avpLingue[i];

            break;
          }
        }
      }
      console.log("changeLang", lingua);
      // setCurrentAvpLingua(lingua);
      setSelectedLingua(lingua);
      loadGrafo(avpAssistente, lingua.idLingua);
    } else {
      loadGrafo(avpAssistente, selectedLingua.idLingua);
    }

    //
  }
  return (
    <div style={{ position: "relative" }}>
      <AvpHeader selectedMenuId={"avp"} />

      <BreadCrumb items={breadCrumb} helpLink={"help.html#modificagrafo"} />

      <Collapse
        in={memoAlert === "success"}
        timeout={{ enter: 1000, exit: 1000 }}
        addEndListener={() => {
          setTimeout(() => {
            setAlertMessage(false);
          }, 2000);
        }}
      >
        <Alert
          variant="filled"
          severity="success"
          onClose={() => {
            setAlertMessage("");
          }}
        >
          {selectedLinguaTesto?.AvpGraphDetailAlertSuccess}
        </Alert>
      </Collapse>
      <Collapse in={memoAlert === "error"}>
        <Alert
          variant="filled"
          severity="error"
          onClose={() => {
            setAlertMessage("");
          }}
        >
          {selectedLinguaTesto?.AvpGraphDetailAlertError}
        </Alert>
      </Collapse>

      {avp != null && avp !== undefined && (
        <div
          style={{
            position: "relative",
            width: "100vw",
            height: "85vh",
            minWidth: 1500,
            minHeight: 500,
            backgroundColor: "white",
          }}
        >
          <NewGraph
            style={{ zIndex: 50 }}
            tipiAvvio={tipoAvvioList}
            lingue={avpLingue}
            currentLingua={selectedLingua}
            nodeActionCallback={handleNodeActionCallback}
          />
          <div
            style={{
              backgroundColor: "white",
              position: "absolute",
              width: 55,
              height: 14,
              zIndex: 10,
              bottom: 0,
              right: 0,
            }}
          ></div>
        </div>
      )}
    </div>
  );
}
